import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD0N5o9vqxz6cz1KulbBn6evSEJ41g7hsQ",
  authDomain: "sproutco-2cf52.firebaseapp.com",
  projectId: "sproutco-2cf52",
  storageBucket: "sproutco-2cf52.firebasestorage.app",
  messagingSenderId: "356851484489",
  appId: "1:356851484489:web:29d77ec9eb595f94493c98",
  measurementId: "G-X3DY3BRNQ3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export  { db }
export const functions = getFunctions(app, 'us-central1');